import React from 'react';

export const TranslationContext = React.createContext({});
export const NavigationContext = React.createContext({});
export const FieldStateContext = React.createContext({});

